import { prompt, type PromptDefinition } from './models';

export const MAINTENANCE_TECHNICIAN_PROMPTS = [
    prompt(
        'Keep it running',
        'What maintenance is due in this building this month?',
        'What maintenance is due across my buildings this month?'
    ),
    prompt(
        'Keep it running',
        'What happened during the last service of equipment in this building?',
        'Which buildings have equipment needing follow-up from the last service?'
    ),
    prompt(
        'Manage risk',
        'What isolation or permit instructions are documented for work in this building?',
        'Which buildings have missing isolation or permit instructions for planned maintenance?'
    ),
    prompt(
        'Keep it running',
        'Find equipment service instructions for this building about…',
        'Find equipment service instructions across my buildings about…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        'Which faults have recurred after repairs in this building?',
        'Which buildings have repeat faults after recorded repairs?'
    ),
    prompt(
        'Keep it running',
        'Where are the equipment manuals and asset identifiers for this building?',
        'Which buildings have equipment with missing manuals or identifiers?'
    ),
    prompt(
        'Keep it running',
        'What parts were replaced during recent maintenance in this building?',
        'Compare recent replacement parts recorded across my buildings.'
    ),
    prompt(
        'Keep it running',
        'Find fault and repair notes for this building involving…',
        'Find fault and repair notes across my buildings involving…',
        'prefill'
    ),
    prompt(
        'Manage risk',
        'What hazards should I review before maintenance work in this building?',
        'Which buildings have recorded hazards affecting my planned maintenance visits?'
    ),
    prompt(
        'Keep it running',
        'Which inspection readings for this building need follow-up according to the reports?',
        'Which buildings have inspection readings flagged for technician follow-up?'
    ),
    prompt(
        'Keep it running',
        "What evidence is missing from this building's recent service records?",
        'Which buildings have service records that technicians need to complete?'
    ),
    prompt(
        'Keep it running',
        'Trace the maintenance history of equipment in this building identified as…',
        'Compare maintenance histories across my buildings for equipment identified as…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
